<section class="financiamiento-section">
    <div class="financiamiento-overlay"></div>
    <div class="hero-container">
        <h1 class="hero-title animate-hero-title">
            Consultoría Fiscal y Legal
        </h1>
    </div>
</section>

<section class="services-detail-section" #servicesSection>
    <div class="container">
        <div class="services-detail-content">

            <!-- Columna izquierda: Texto + Imagen -->
            <div class="services-left">
                <h2 class="services-intro animate-on-scroll" [class.visible]="isVisible" style="--delay: 0s">
                    Trabajamos junto a especialistas para brindar soluciones que incluyen:
                </h2>
                <div class="services-image animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.2s">
                    <img src="/assets/Tarjetas servicios/6 Consultoria.jpg" alt="Consultoría Fiscal y Legal">
                </div>
            </div>

            <!-- Columna derecha: Dos secciones de listas -->
            <div class="services-right">

                <!-- Sección 1: Consultoría Contable y Fiscal -->
                <div class="service-subsection animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.3s">
                    <h3 class="service-subtitle">Consultoría Contable y Fiscal</h3>
                    <ul class="services-list">
                        <li class="service-item">
                            <span class="service-icon">+</span>
                            <span class="service-text">Balances y liquidaciones.</span>
                        </li>
                        <li class="service-item">
                            <span class="service-icon">+</span>
                            <span class="service-text">Optimización de carga tributaria.</span>
                        </li>
                        <li class="service-item">
                            <span class="service-icon">+</span>
                            <span class="service-text">Análisis de eficiencia fiscal.</span>
                        </li>
                        <li class="service-item">
                            <span class="service-icon">+</span>
                            <span class="service-text">Planificación tributaria.</span>
                        </li>
                    </ul>
                </div>

                <!-- Sección 2: Apoyo Legal Empresarial -->
                <div class="service-subsection animate-on-scroll" [class.visible]="isVisible" style="--delay: 0.5s">
                    <h3 class="service-subtitle">Apoyo Legal Empresarial</h3>
                    <ul class="services-list">
                        <li class="service-item">
                            <span class="service-icon">+</span>
                            <span class="service-text">Asesoramiento societario.</span>
                        </li>
                        <li class="service-item">
                            <span class="service-icon">+</span>
                            <span class="service-text">Revisión Contractual.</span>
                        </li>
                        <li class="service-item">
                            <span class="service-icon">+</span>
                            <span class="service-text">Asistencia legal para operaciones financieras.</span>
                        </li>
                        <li class="service-item">
                            <span class="service-icon">+</span>
                            <span class="service-text">Coordinación con abogados especializados.</span>
                        </li>
                    </ul>
                </div>

            </div>

        </div>
    </div>
</section>

<app-cta-section></app-cta-section>